import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import {formatDate, removeLastSign} from "../../pages/utils";
import { Consts } from "../../pages/consts";

const DrugRow = ({
  drugKey,
  drug,
  handleOpenIntakeDialog,
  onDeleteDrug
}) => {
  const { t: t } = useTranslation();
  let substance = drug?.activeSubstance; //for showing on GUI

  if(substance && substance?.length > 0 && typeof substance === 'string'){
    if(substance === Consts.ANY){
      substance = t("not_specified");
    }

    substance = substance?.replaceAll("&&&", ";");
  } else if (substance && substance?.length > 0 && Array.isArray(substance)) {
    substance = substance?.join(', ');
  } else {
    substance = t("not_specified");
  }

  let product = drug?.productName && drug?.productName !== Consts.ANY
    ? removeLastSign(drug?.productName, ",")
    : t("not_specified")

  const checkIntakes = () => {
    if(drug?.intakes?.length > 0){
      const intakesWithDosages = drug?.intakes?.filter(intake => !isNaN(intake?.dosage)
        && intake?.dosage > 0);

      if(intakesWithDosages?.length > 0){
        return true;
      }
    }

    return false;
  }

  return (
    <div key={drugKey} className="w3-row w3-mobile w3-padding-small">
      <div className="w3-col s3 w3-mobile w3-padding-small">
        <label style={ {display: 'block', wordWrap: 'break-word', whiteSpace: 'normal'} }>{product}</label>
      </div>
      <div className="w3-col s2 w3-mobile w3-padding-small">
        <label style={ {display: 'block', wordWrap: 'break-word'} }>{substance}</label>
      </div>
      <div className="w3-col s2 w3-mobile w3-padding-small">
        <label style={ {display: 'block', wordWrap: 'break-word'} }>{drug?.atc ? drug?.atc : "-"}</label>
      </div>
      <div className="w3-col s2 w3-mobile w3-padding-small">
        <label style={ {display: 'block', wordWrap: 'break-word', whiteSpace: 'normal'} }>{formatDate(drug?.startDate)}</label>
      </div>
      <div className="w3-col s3 w3-mobile w3-padding-small">
        <div className="w3-container">
          {checkIntakes() ? (
            <button
              className="w3-btn w3-round-xlarge w3-theme-d5 w3-padding-small"
              onClick={() => handleOpenIntakeDialog(drug, false)}
            >
              {t("view")}
            </button>
          ) : (
            <>
              {drug?.intakeType === Consts.ON_DEMAND ? (
                <label>{t("on_demand")}</label>
              ) : (
                <button
                  className="w3-btn w3-round-xlarge w3-padding-small specifyButton"
                  onClick={() => handleOpenIntakeDialog(drug, true)}
                >
                  {t("specify")}
                </button>
              )}
            </>
          )}
          <button
            type="button"
            onClick={() => onDeleteDrug(drug)}
            className="w3-btn w3-round-xlarge w3-theme-d5 w3-margin-left w3-right w3-padding-small"
          >
            <FontAwesomeIcon icon={faTrash} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default DrugRow;
